// extracted by mini-css-extract-plugin
module.exports = {"container":"KeyboardInput_container__Zwe4F","invertedColors":"KeyboardInput_invertedColors__2s3F3"};